<template>
    <div>
        <AdmPanel>
            <h2 slot="header_title">上市公司舆情录入统计</h2>
            <FilterBar slot="header_buttons" :value="conditions" :condition="options.filter_rules" @search="changeQuery">
            <iv-form-item>
            <iv-button
                :disabled="loader[INPUT_STATISTICS]"
                type="info"
                @click="changeQuery()"
            >
                <iv-icon type="md-search" size="14" style="vertical-align:text-bottom"/> 查询
            </iv-button>
            </iv-form-item>
            </FilterBar>
            <iv-table
                    class="adm-table"
                    :columns="columns"
                    :loading="loader[INPUT_STATISTICS]"
                    :data="list.data">
            </iv-table>
            <!-- <template v-if="list.last_page > 1">
                <div slot="footer" class="pull-right">
                    <iv-page
                            @on-change="pageChanged"
                            :current="list.current_page"
                            :page-size="10"
                            show-elevator
                            show-total
                            :total="list.total">
                    </iv-page>
                </div>
            </template> -->
        </AdmPanel>
    </div>
</template>
<script>
import Fecha      from '@/utils/type/Fecha'
import AuditModel from "@/models/AuditModel";
import TaskModel from "@/models/TaskModel";

import ModelMixin from "@/mixins/Model.mixin";
import StatusMixin from "@/mixins/Status.mixin";
import LoaderMixin from "@/mixins/Loader.mixin";
import contact from "@/utils/contact";
import { conditioner, getNearlyAMonth, renderFilterBar } from '@/utils/';
import FilterBar from "@/components/FilterBar_X2";

const TASK = TaskModel.ModelName
const AUDIT = AuditModel.ModelName;
const INPUT_STATISTICS = 'inputStatistics'

const options = {}

const filter_rules = [
  { name: "userInCharge", type: "Select", options: [], title: "操作员", default: "", placeholder: "操作员", clearable: true, style: { width: "120px" } },
  {name: "timeScope", type: "Daterange", format: 'yyyy-MM-dd', placeholder: "目标完成时间" },
]

const _conditioner = conditioner(
      {//ui to url
        timeScope       : {type: val=> val.length <= 0 || val.every(item=>!item) ? '' : JSON.stringify(val.map(date=>Fecha.format(date,'YYYY-MM-DD'))) , default: ""},
        userInCharge: { type: String, default: "" },
      },
      {//url to ui
        timeScope       : {type:  val=> !val ? [] : JSON.parse(val).map(date=>Fecha.parse(date,'YYYY-MM-DD')), default: getNearlyAMonth()},
        userInCharge: { type: String, default: "" },
      }
  )
function columns(vm){
  return [
      {
          title: "负责人",
          key: "userInCharge",
          align: "center",
          minWidth: 60,
      },
      {
          title: "行业",
          key: "industry",
          align: "center",
          minWidth: 60,
      },
      {
          title: "总爬取舆情数量",
          key: "sentimentCount",
          align: "center",
          minWidth: 120,
      },
      {
          title: "收录舆情数量",
          key: "includeCount",
          align: "center",
          minWidth: 150,
      },
        {
          title: "排除舆情数量",
          key: "excludeCount",
          align: "center",
          minWidth: 90
      },
        {
          title: "数据收录率",
          key: "includeRate",
          align: "center",
          minWidth: 90
      },
      {
          title: "进度",
          key: "completeRate",
          align: "center",
          minWidth: 80
      }
  ]
}

export default {
        name: "statistics",
        mixins:[
            LoaderMixin(AUDIT,TASK, INPUT_STATISTICS),
            ModelMixin({
                contact,
                models:[
                    AuditModel,
                    TaskModel
                ]
            })
        ],
        data() {
            return {
                columns: columns(this),
                conditions: {
                    ..._conditioner.default()
                },
                AUDIT,
                TASK,
                INPUT_STATISTICS,
                list: {
                    data: [],
                    last_page:0,
                    current_page:1
                },
                options: {
                    ...options,
                    users:[],
                    filter_rules
                },
                sources:{
                    FilterBar:{
                        loading:false
                    }
                },
            }
        },
        async mounted () {
            const { query, params } = this.$route
            this.conditions = _conditioner.serialize({...query,...params}) //处理成支持UI的格式
            await this.getDefaultTimeScope()
            const users = await this.refreshUsers()
            renderFilterBar(this.options.filter_rules)('userInCharge', users.data.map(val=>({id:val, title:val})))
            this.refreshStatistics()
        },
        beforeRouteUpdate(to, from, next){
            this.$nextTick(async ()=>{
                const { query, params } = to
                this.conditions = {
                    ..._conditioner.default(),
                    ..._conditioner.serialize({...query,...params}) //处理成支持UI的格式
                }
                this.refreshStatistics()
            })
            next();
        },
        methods: {
            async refreshStatistics(query=this.conditions){
                this.$$loading(INPUT_STATISTICS);
                this.list = await this.$$active(AUDIT, 'inputListedSentimentStatistics', _conditioner.parse(query));
                this.list.current_page = _conditioner.parse(query).offset ? _conditioner.parse(query).offset / _conditioner.parse(query).limit + 1 : 1
                this.list.last_page = this.list.total / _conditioner.parse(query).limit
                this.$$loaded(INPUT_STATISTICS);
            },
            async refreshUsers(){
              const result = await this.$$active(TASK, 'users')
              if(result instanceof Error) return
              return this.options.users = result
            },
            async getDefaultTimeScope(){
              const result = await this.$$active(AUDIT, 'listedSentimentDefaultTimeScope')
              if(result instanceof Error) return
              console.log(result)
              return this.conditions = { ...this.conditions, ..._conditioner.serialize({timeScope:JSON.stringify(result.data)}) }
            },
            pageChanged(page){
                this.$router.push({ name: this.$route.name, query: { ...this.$route.query, offset: ( page - 1 ) *  _conditioner.parse(this.conditions).limit}, params: this.$route.params });
            },
            mergeQuery(query){
              return { ...this.conditions, ...query}
            },
            changeQuery(query=this.conditions, params = this.$route.params) {
                this.refreshStatistics()
            },
        },
        components:{
            FilterBar
        }
    }
</script>
<style lang="postcss" scoped>
.inline-checkList {
  display: inline-block;
  margin-right: 20px;
}
.inline-checkList >>> span {
    display: inline-block !important;
}

.inline-checkList >>> div {
  display: inline-block !important;
}
</style>
